<div class="product-details">
    <h1 class="product-title">{{ product.name }}</h1>
    
    <!--
    <div class="ratings-container">
        <div class="ratings">
            <div class="ratings-val" [style.width]="product.ratings * 20 + '%'"></div>
            <span class="tooltip-text">{{ product.ratings.toFixed(2) }}</span>
        </div>
        <span class="ratings-text">( {{ product.review }} Reviews )</span>
    </div>
    -->

    <div class="product-price" *ngIf="(!product.stock || product.stock < 1) && showStock && product.variants.length < 1 else elseBlock">
        <!--<span class="out-price">€{{ product.price.toFixed(2) }}</span>-->
        <div class="product-price" *ngIf="minPrice == maxPrice  else elseBlockMinMax">€{{ minPrice.toFixed(2) }} </div>
        <ng-template #elseBlockMinMax>
            <div class="product-price">
                <span class="new-price">€{{ minPrice.toFixed(2) }}</span>
                <span class="old-price">€{{ maxPrice.toFixed(2) }}</span>
            </div>
        </ng-template>
    </div>

    <ng-template #elseBlock>
        <div class="product-price" *ngIf="minPrice == maxPrice else elseBlock">€{{ minPrice.toFixed(2) }}</div>
        <ng-template #elseBlock>
            <div class="product-price" *ngIf="product.variants.length == 0  else elseBlock">
                <span class="new-price">€{{ minPrice.toFixed(2) }}</span>
                <span class="old-price">€{{ maxPrice.toFixed(2) }}</span>
            </div>
            <ng-template #elseBlock>
                <div class="product-price" *ngIf="product.var_rel[1].sale_price == 0  else showSalePrice"> <!--product.var_rel[1].sale_price == 0 &&-->
                    €{{minPrice.toFixed(2)}} - €{{maxPrice.toFixed(2)}}
                </div>
                <ng-template #showSalePrice>
                    <div class="product-price" *ngIf="oldmax != maxPrice else showonlyminmax">
                        <span class="new-price">€{{ minPrice.toFixed(2) }} - €{{oldmin.toFixed(2)}}</span>
                        <span class="old-price">€{{oldmax.toFixed(2)}} - €{{ maxPrice.toFixed(2) }}</span>
                    </div>                    
             </ng-template>
             <ng-template #showonlyminmax>
                <div class="product-price">
                    <span class="new-price">€{{ minPrice.toFixed(2) }}</span>
                    <span class="old-price">€{{ maxPrice.toFixed(2) }}</span>
                </div>
             </ng-template>
            </ng-template>
        </ng-template>
    </ng-template>

    <div class="product-vat">{{apiService.vattext}}</div>
    <div class="product-content">
        <p>{{ product.short_desc }}</p>
    </div>


    <div *ngIf="product.variants.length > 0">
<!--
        <div class="details-filter-row details-row-size">
            <label>Color:</label>
            <div class="product-nav product-nav-dots">
                <a href="javascript:;" [class.active]="item.color == selectedVariant.color"
                    [class.disabled]="item.disabled" [style.background-color]="item.color"
                    *ngFor="let item of colorArray" (click)="selectColor($event, item)"></a>
            </div>
        </div>
    -->    
<!--
        <div class="details-filter-row details-row-size">
            <label for="size">Variant:</label>
            <div class="select-custom">
                <select name="size" id="size" class="form-control" [value]="selectedVariant.size"
                    (change)="selectSize($event)">
                    <option value="" [selected]="''==selectedVariant.size">Select a variant</option>
                    <option [value]="item.size" *ngFor="let item of sizeArray"
                    [selected]="item.size == selectedVariant.size" (onChange)="updatePrice($event,item)">{{ item.size }}</option>
                </select>
            </div>

            <a href="javascript:;" class="size-guide mr-4"><i class="icon-th-list"></i>size guide</a>
            <a href="javascript:;" (click)="clearSelection()"
                *ngIf="selectedVariant.color || selectedVariant.size != ''">clear</a>
        </div>    
   -->
        <div class="details-filter-row details-row-size">
            <label for="size">Variant:</label>
            <div class="select-custom">
                <select name="size" id="size" class="form-control" [value]="selectedRelated.name" 
                    (change)="selectSizeRelated($event)">                    
                    <option [value]="item.name" *ngFor="let item of relatedArray"
                    [selected]="item.name == selectedRelated.name">{{ item.name }}</option> <!---->
                </select>
            </div>

            <!--
            <a href="javascript:;" class="size-guide mr-4"><i class="icon-th-list"></i>size guide</a>
            <a href="javascript:;" (click)="clearSelection()"
                *ngIf="selectedRelated.name != ''">clear</a>
            -->
        </div>  
   
    </div>
 

    <div class="variation-price price-none">
        <div class="product-price" *ngIf="!disableAddtoCart">
           <!-- €{{ selectedVariant.price ? selectedVariant.price.toFixed( 2 ) : 0 }}
           €{{ selectedRelated.price ? selectedRelated.price.toFixed( 2 ) : 0 }}    -->
           <div class="product-price" *ngIf="varMinPrice != varMaxPrice  else elseBlock">
            <span class="new-price">€{{ varMinPrice.toFixed(2) }}</span>
            <span class="old-price">€{{ varMaxPrice.toFixed(2) }}</span>
        </div>
        <ng-template #elseBlock>
            <div class="product-price">€ {{varMinPrice.toFixed(2)}}</div>
        </ng-template>                 
        </div>
    </div>

    <div class="details-filter-row details-row-size">
        <label for="qty">Qty:</label>
        <molla-quantity-input [max]="product.stock" (changeQty)="onChangeQty( $event )" [value]="qty" #quantityInput>
        </molla-quantity-input>
    </div>

    <div class="product-details-action">
        <a href="javascript:;" class="btn-product btn-cart"
            [class.btn-disabled]="disableAddtoCart" 
            (click)="addCart( $event, 0 )"><span>add to cart</span></a> <!--!cartService.canAddToCart( product, qty ) || ( selectedVariant.color && selectedVariant.size != '' )-->

        <div class="details-action-wrapper">
            <a href="javascript:;" class="btn-product btn-wishlist" 
                (click)="addToWishlist($event)"><!--[class.added-to-wishlist]="isInWishlist()"-->
                <span>Add to Wishlist</span><!--{{ isInWishlist() ? 'Go' : 'Add' }}-->
            </a>
        </div>
    </div>
        

    <!-- *** Product available in the following stores ***-->
    <div class="product-details-footer" *ngIf="prod_wharehouses?.length>0 && product.stock > 0 && product.variants.length<1 && showStock else showVariantsStock"> <!-- it was &&-->
        <div class="product-cat w-100 text-truncate">
            <span>The product is available in the following stores:</span>             
            <span *ngFor="let item of prod_wharehouses"><br>{{item.WH_Web_Description}} </span>
        </div>        
    </div>

        <ng-template #showVariantsStock>
            <div class="product-details-footer" *ngIf="!variant_product_out_of_stock && showStock && !allRelatedOutofStock && product.variants.length>1"> <!-- it was &&-->
                <div class="product-cat w-100 text-truncate">
                    <span>The product is available in the following stores:</span>             
                    <span *ngFor="let item of prod_wharehouses"><br>{{item.WH_Web_Description}} </span>
                </div>        
            </div>
        </ng-template>

    <span *ngIf="product.stock <1 && showStock  && product.variants.length < 1" class="out-of-stock" (click)="addToNotifyList($event, product)"> Get notified when available</span>
    <!-- *** this is only for products who have variants. when you select a variant it checks if is out of stock and then enables get notified-->
    <span *ngIf="variant_product_out_of_stock" class="out-of-stock" (click)="addToNotifyListVariant($event)"> Get notified when available</span>
    <br><br>

    <!---<a href="javascript:;" class="btn-product-icon btn-watch-video" title="Watch Video" *ngIf="has_video" 
                (click)="watchVideo($event,product)">
                <span>Watch Video</span>Watch Video</a>
                <iframe width="560" height="315" [src]="extractSrcUrl(product.videoURL.toString())" frameborder="0" allowfullscreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
    -->
    <div class="product-details-footer">
        <div class="product-cat w-100 text-truncate">
            <span>Category:</span>
            <span *ngFor="let cat of product.category; let i =index">
                <a [routerLink]="['/shop/sidebar/list']"
                    [queryParams]="{subcategory: cat.id}">{{ cat.name }}
                </a>{{ i < product.category.length - 1 ? ',' : '' }}                    
            </span>
        </div>

        <div class="social-icons social-icons-sm">
            <span class="social-label">Share:</span>
            <a target="_blank" href="https://www.facebook.com/sharer.php?u={{websiteurl}}&t={{product.name}}&db_conn_string={{apiService.shareProductConnStr}}" 
                 class="social-icon" title="Facebook"><i class="icon-facebook-f"></i>
            </a>
            <!--<a href="javascript:;" class="social-icon" title="Twitter"><i class="icon-twitter"></i></a>-->
            <!--<a href="javascript:;" class="social-icon" title="Instagram"><i class="icon-instagram"></i></a>-->
            <!--<a href="javascript:;" class="social-icon" title="Pinterest"><i class="icon-pinterest"></i></a>-->
        </div>        
    </div>
    
    
    <div class="sticky-bar d-none">
        <div class="container">
            <div class="row">
                <div class="col-6">
                    <figure class="product-media">
                        <a [routerLink]="['/product/default/'+ product.id]">
                            <molla-image [src]="SERVER_URL + product.sm_pictures[0].url" alt="Product"
                                class="product-image">
                            </molla-image>
                        </a>
                    </figure>
                    <h3 class="product-title">
                        <a [routerLink]="['/product/default/'+ product.id]">{{ product.name }}</a>
                    </h3>
                </div>
                <div class="col-6 justify-content-end">
                    <div class="product-price" *ngIf="selectedVariant.color && selectedVariant.size != '' else variationPrice">
                        €{{ selectedVariant.price ? selectedVariant.price.toFixed( 2 ) : 0 }}
                    </div>
                    <ng-template #variationPrice>
                        <div class="product-price" *ngIf="(!product.stock || product.stock < 1) && product.variants.length < 1 else elseBlock">
                            <span class="out-price">€{{ product.price.toFixed(2) }}</span>
                        </div>

                        <ng-template #elseBlock>
                            <div class="product-price" *ngIf="minPrice == maxPrice else elseBlock">
                                €{{ minPrice.toFixed(2) }}</div>
                            <ng-template #elseBlock>
                                <div class="product-price" *ngIf="product.variants.length == 0 else elseBlock">
                                    <span class="new-price">€{{ minPrice.toFixed(2) }}</span>
                                    <span class="old-price">€{{ maxPrice.toFixed(2) }}</span>
                                </div>
                                <ng-template #elseBlock>
                                    <div class="product-price">€{{minPrice.toFixed(2)}}&ndash;€{{maxPrice.toFixed(2)}}
                                    </div>
                                </ng-template>
                            </ng-template>
                        </ng-template>
                    </ng-template>

                    <molla-quantity-input [max]="product.stock" (changeQty)="onChangeQty2( $event )" [value]="qty2">
                    </molla-quantity-input>

                    <div class="product-details-action">
                        <a href="javascript:;" class="btn-product btn-cart"
                            [class.btn-disabled]="!cartService.canAddToCart( product, qty2 ) || ( product.variants.length > 0 && !( selectedVariant.color && selectedVariant.size != '' ) )"
                            (click)="addCart( $event, 1 )"><span>add to cart</span></a>

                        <div class="details-action-wrapper ml-0">
                            <a href="javascript:;" class="btn-product btn-wishlist"
                                 (click)="addToWishlist($event)"><!--[class.added-to-wishlist]="isInWishlist()"-->
                                <span>Add to wishlist</span><!--{{ isInWishlist() ? 'go' : 'add' }}-->
                            </a>
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
    </div>
</div>